import React, { Component } from 'react';
// utils
import moment from 'moment';
// styles
import styles from './ProgressGoalLine.mod.css';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

class ProgressGoalLine extends Component {
  state = {
    progress: 0
  };

  componentDidMount() {
    const progress = this.getProgress();
    this.setState({
      progress
    });
  }

  getProgress = () => {
    const { deadline, start } = this.props.goal;
    const deadlineDate = moment(start).add(deadline, 'd');
    const startDate = moment(start);
    const currentDate = moment();

    if (!start || !deadline) {
      return null;
    }

    if (!start || deadlineDate.diff(startDate) <= 0) {
      return 100;
    }

    return Math.min(
      Math.floor(
        100 -
          (moment.duration(deadlineDate.diff(currentDate)).asDays() * 100) /
            moment.duration(deadlineDate.diff(startDate)).asDays()
      ),
      100
    );
  };

  render() {
    const { color, goal } = this.props;
    const { progress } = this.state;

    const hintLabel = `${
      goal.value.length > 24
        ? goal.value.substr(0, 24).trim() + '...'
        : goal.value
    } ${progress}%`;

    return (
      <div
        className={cx('progress-goal', 'hint--bottom', {
          hidden: progress === null
        })}
        data-hint={hintLabel}
      >
        <span
          style={{ backgroundColor: color, width: `${progress}%` }}
          className={cx('progress-line')}
        />
      </div>
    );
  }
}

export default ProgressGoalLine;



// WEBPACK FOOTER //
// ./src/containers/RecoveryPlan/components/ProgressGoalLine.jsx